import axios from "../../../axios/index.js"
import store from "../../../../store/store.js"
import { mainSetting } from '@/gloabelConstant.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = [] 

function onAccessTokenFetched(access_token) {
  //subscribers = subscribers.filter(callback => callback(access_token))
  localStorage.setItem("expiresIn", access_token.data.expiresIn)
  localStorage.setItem("accessToken", access_token.data.accessToken)
  localStorage.setItem("refreshToken", access_token.data.refreshToken)
  store.commit('auth/SET_BEARER', localStorage.getItem("accessToken"))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init(vm) {
    axios.interceptors.request.use(function(successfulReq) {
      
      if(successfulReq.url!="/GetUserNotification")
         vm.$vs.loading();
      return successfulReq;
    }, 
    function(error) {
      vm.$vs.loading.close();
      return Promise.reject(error);
    });

    store.commit('auth/SET_BEARER', localStorage.getItem("accessToken"))
     
    axios.interceptors.response.use(function (response) {
      vm.$vs.loading.close();
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config
      vm.$vs.loading.close();
      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch("auth/fetchAccessToken")
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false 
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = 'Bearer ' + access_token
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login(email, pwd) { 
    return axios.post("/login", {email: email, password: pwd,FCMToken:mainSetting.FCMToken})
  },
  registerUser(confPassword, email, pwd) {
    return axios.post("/register", {confirmPassword: confPassword, email: email, password: pwd})
  },
  refreshToken() {
    return axios.post("/refresh", {refreshToken: localStorage.getItem("refreshToken")})
  }
}
